import styled from "styled-components";

export const LandingPrivacyStyled = styled.div`
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  margin-bottom: 164px;
  align-items: center;
`;

export const LandingPrivacyTitle = styled.h3`
  font-family: "Raleway";
  font-weight: 400;
  font-size: 56px;
  line-height: 72px;
  margin-bottom: 24px;
  color: #000000;
`;

export const LandingPrivacyImg = styled.div`
  margin-left: 40px;
  background: linear-gradient(152.97deg, #ffffff 13.39%, #c7c7c7 87.18%);
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 232px;
  height: 232px;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
  padding-top: 46px;

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(
      152.97deg,
      rgba(236, 213, 213, 0.6) 13.39%,
      rgba(220, 220, 220, 0) 87.18%
    );
    border-radius: 100%;
    width: 232px;
    height: 232px;
    z-index: -1;
  }

  & .lockFront2 {
    position: absolute;
    top: 100px;
    left: 79px;
  }

  & .lockVer {
    position: absolute;
    opacity: 0;
    top: 110px;
    left: 85px;
  }

  & .lockUpper {
    position: absolute;
    z-index: -1;
    top: 5px;
    left: 85px;
  }
`;

export const LandingPrivacyTitleList = styled.ul`
  font-weight: 400;
  font-size: 18px;
  line-height: 32px;
  padding-left: 18px;
  gap: 72px;
  display: flex;

  & li {
    position: relative;
  }

  & li:after {
    content: "";
    position: absolute;
    width: 5px;
    height: 14px;
    left: -18px;
    top: 8px;
    background: #ff4d00;
    border-radius: 14px;
  }
`;
